import { render, staticRenderFns } from "./CityAdd.vue?vue&type=template&id=5cfc6ce1&scoped=true&"
import script from "./CityAdd.vue?vue&type=script&lang=js&"
export * from "./CityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc6ce1",
  null
  
)

export default component.exports